import * as React from 'react';
import { useDispatch } from 'react-redux';

import { FilterSingleChoose } from '../../../../components/FilterSingleChoose';
import { ESpecialistTypes } from '../../../../constants/searchRealtors';
import { setSpecialistType } from '../../../../actions/searchRealtors';
import { useSpecialistType } from '../../../../hooks/selectors/searchRealtors';

const SPECIALIST_TYPE_ITEMS = new Map([
  [ESpecialistTypes.Realtors, 'Риелторы'],
  [ESpecialistTypes.Agencies, 'Агентства'],
]);

export const SpecialistTypeContainer: React.FC = () => {
  const dispatch = useDispatch();
  const specialistType = useSpecialistType();

  const handleSetSpecialistType = React.useCallback(
    (specialistType: ESpecialistTypes) => {
      dispatch(setSpecialistType(specialistType));
    },
    [dispatch],
  );

  return (
    <FilterSingleChoose
      label=""
      items={SPECIALIST_TYPE_ITEMS}
      onSelectItem={handleSetSpecialistType}
      selectedItemKey={specialistType}
    />
  );
};

SpecialistTypeContainer.displayName = 'SpecialistTypeContainer';
